var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-info-card',{staticClass:"mb-12",attrs:{"title":("Comments(" + (_vm.comments.length) + ")")}},_vm._l((_vm.comments),function(comment,i){return _c('news-comment',_vm._b({key:i},'news-comment',comment,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }